module.exports = __webpack_public_path__ + "h5/img/summer-goBack.063fe2f7.png";